<template>
  <v-row
    v-if="formModel.listViewItems && getList && getList.length >0"
    class="ma-0"
  >
    <v-col
      cols="12"
      class="pt-0 pb-0"
    >
      <ul class="ps-6">
        <li
          v-for="(item, index) in getList"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ListView',
  components: {},
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({ listViewItems: null }),
    },
  },
  data() {
    return {};
  },
  computed: {
    getList() {
      if (!Array.isArray(this.formModel.listViewItems)) {
        var value = [];
        value.push(this.formModel.listViewItems);
        return value;
      }
      return this.formModel.listViewItems;

    },
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>
